import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'litmus-input',
    templateUrl: './litmus-input.component.html',
    styleUrls: ['./litmus-input.component.scss'],
    standalone: false
})
export class LitmusInputComponent implements OnInit, OnChanges {
  typeList: any = ["text", "textarea", "number"];
  @Input() type: string = "text";
  @Input() disabled: boolean = false
  @Input() placeholder: string = "";
  @Input() maxlength!:number;
  @Input() rows!:number;
  @Input() min!:number;
  @Input() max!:number;
  @Input() value:any;
  @Input() readOnly:boolean=false;
  @Output() input: any = new EventEmitter<any>()
  @Output() change: any = new EventEmitter<any>()
  @Output() enter: any = new EventEmitter<any>()
  @Output() keyup: any = new EventEmitter<any>()
  @Output() keydown: any = new EventEmitter<any>()

  constructor() {

  }
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }


  onInput(event: any) {
    event.stopPropagation();
    this.checkConditions(event);
    this.input.emit(event.target.value);
  }
  onChange(event: any) {
    event.stopPropagation();
    this.checkConditions(event);
    this.change.emit(event.target.value);
  } 
  onEnter(event: any) {
    event.stopPropagation();
    this.checkConditions(event);
    this.enter.emit(event.target.value);
  }
  onKeyup(event: any) {
    event.stopPropagation();
    this.checkConditions(event);
    this.keyup.emit(event.target.value);
  }
  onKeydown(event: any) {
    event.stopPropagation();
    this.checkConditions(event);
    this.keydown.emit(event.target.value);
  }

  checkConditions(event){
    let text = event.target.value;
    text = text.trim();
    if(this.type == 'number'){
      const reg = new RegExp('^[0-9]+$');
      if(event.keyCode == 69|| !reg.test(text) ){
        this.value = '';
        event.target.value = '';
      }
    }else if(text == ''){
      this.value = '';
      event.target.value = '';
    }
  }
}
